<template>
  <div class="app-select account-select">
    <v-select
      v-model="data[field]"
      class="app-select__control"
      :reduce="(account) => account.id"
      label="name"
      :options="accounts"
      :append-to-body="true"
      :clearable="false"
      :searchable="false"
      placeholder="Select account"
    >
      <template #selected-option="option">
        <span class="app-select__label">{{ option.name }}</span>
      </template>
      <template #option="option">
        <span class="app-select__label">{{ option.name }}</span>
      </template>
    </v-select>
  </div>
</template>
<script>
export default {
  props: ['data', 'field', 'accounts'],
};
</script>

<style scoped>
.app-select {
  width: 100%;
}

.app-select__label {
  color: inherit;
  font-weight: 700;
  font-size: 0.95rem;
}
</style>
